import context from './context'

export { useLoading } from './useLoading'
export { withLoading } from './withLoading'
export const LoadingProvider = context.Provider
